import { Text } from './styles';

interface TextListProps {
  textList: string[];
  textVariant: string;
  textColor: string;
}

export const TextList = ({ textList, textVariant, textColor }: TextListProps) => {
  return (
    <>
      {textList.map((text, index) => (
        <Text key={`${text}.${index}`} variant={textVariant} color={textColor}>
          {text}
        </Text>
      ))}
    </>
  );
};
